// A crab, modelled facing +X: a flat red shell, eight legs, two raised
// claws and stalked eyes. Ported 1:1 from age-of-mcp's classic crab.ts,
// restoring its splayed-leg loop + shell/claw/eye composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.IcosahedronGeometry(0.026, 0), color: "#c8482e",
      position: [0, 0.018, 0], scale: [1.1, 0.5, 1.4] },             // shell
  ];
  // Legs splayed left and right.
  for (const side of [1, -1]) {
    for (let i = 0; i < 3; i++) {
      parts.push({ geometry: new THREE.CylinderGeometry(0.003, 0.002, 0.03, 3),
        color: "#a83a24", position: [(i - 1) * 0.014, 0.012, side * 0.03],
        rotation: [side * 0.8, 0, 0] });
    }
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#d8543a",
      position: [0.03, 0.024, 0.022] },                              // claw
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#d8543a",
      position: [0.03, 0.024, -0.022] },
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#101010",
      position: [0.022, 0.034, 0.008] },                            // eye stalk
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#101010",
      position: [0.022, 0.034, -0.008] },
  );
  return parts;
}

export const crab = defineModel({
  id: "crab",
  batchId: "standard",
  name: "Crab",
  tags: ["creature","crab","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly crab.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.06,
  parts: () => partsFor(),
  animations: [],
});
